export enum TemplateGroups {
  General = "general",
  Showings = "showing",
  SalesMeeting = "salesMeeting",
  Others = "others",
}
